// extracted by mini-css-extract-plugin
module.exports = {"title":"FamilyCard_title__tG67r","container":"FamilyCard_container___vB4Q","content":"FamilyCard_content__joma4","image":"FamilyCard_image__2_f_L"};